import './PhoneInput.css';
import React, { useEffect, useState } from 'react';
import { SitecoreContextReactContext } from '../../../../../../../utils/SitecoreContextReactContext';
import Select from 'react-select';
import { canUseDOM, get } from '../../../../../../../utils';
export const PhoneInput = props => {
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [dropOpened, setDropOpened] = useState(false);
  const rawCountryItems = props.countryItems.map((country, index) => {
    return {
      label: /*#__PURE__*/React.createElement("span", {
        className: "select-item"
      }, country.flagSrc && country.flagSrc.length > 0 && /*#__PURE__*/React.createElement("img", {
        alt: country.code,
        className: "select-item__image",
        src: country.flagSrc
      }), ' ', /*#__PURE__*/React.createElement("span", {
        className: "select-item__text"
      }, country.text || '-')),
      listingLabel: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, country.countryName), " ", `(${country.text || '-'})`),
      value: get(country, 'value') || `${index}-`,
      code: get(country, 'code'),
      countryName: get(country, 'countryName')
    };
  });
  const handleDropMousedown = () => {
    setDropOpened(!dropOpened);
  };
  const handleDropTouchstart = e => {};
  const getInitialCode = () => {
    let countryCode = '';
    if (canUseDOM) {
      var countryNameCookie = document.cookie.split(';').find(item => item.indexOf('user_country_code') > -1);
      if (countryNameCookie) {
        var countryName = countryNameCookie.replace('user_country_code=', '').trim();
        countryCode = countryName !== 'undefined' ? countryName.replace(/\s/g, '') : '';
      }
    }
    const serverCountry = rawCountryItems.find(item => item.code === countryCode) || rawCountryItems[0];
    return serverCountry;
  };
  const [initCode, setinitCode] = useState({});
  useEffect(() => {
    const defaultCode = getInitialCode();
    props.onChange({
      code: defaultCode.value,
      number: props.value.number,
      valid: true
    });
    setinitCode(defaultCode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (props.code && props.code.length) {
      const validCode = props.code.includes('+') ? props.code : `+${props.code}`;
      const langItem = rawCountryItems.find(_ref => {
        let {
          value
        } = _ref;
        return value == validCode;
      });
      langItem && setinitCode(langItem);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.code]);
  return /*#__PURE__*/React.createElement("fieldset", {
    className: `${rtl ? rtlStyles : ltrStyles} ${styles}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `input-wrapper ${dropOpened ? 'input-wrapper--opened' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-wrapper",
    onMouseDown: handleDropMousedown,
    onTouchStart: handleDropTouchstart
  }, /*#__PURE__*/React.createElement(Select, {
    isSearchable: true,
    classNamePrefix: "select-dropdown",
    className: "react-custom-select",
    name: `code-${props.name}`,
    options: rawCountryItems,
    onChange: val => val && props.onChange({
      code: val.value,
      number: props.value.number,
      valid: true
    }),
    value: initCode,
    defaultValue: initCode,
    isRtl: rtl,
    formatOptionLabel: (option, _ref2) => {
      let {
        context
      } = _ref2;
      return context === 'menu' ? option.listingLabel : option.label;
    },
    required: props.required
  })), /*#__PURE__*/React.createElement("input", {
    className: `input-text-primary ${props.phoneInputClass || ''}`,
    type: "text",
    value: props.value.number,
    onBlur: e => props.onBlur && props.onBlur({
      code: props.value.code,
      number: e.currentTarget.value,
      valid: e.currentTarget.validity.valid
    }),
    onChange: e => {
      if (/[^0-9\s]+$/.test(e.target.value)) return;
      props.onChange({
        code: props.value.code,
        number: e.currentTarget.value,
        valid: e.currentTarget.validity.valid
      });
    },
    placeholder: props.placeholder,
    maxLength: props.maxLength,
    minLength: props.minLength,
    name: props.name,
    id: props.itemId,
    required: props.required
  })));
};
const styles = "sxmlsxq";
const rtlStyles = "r3pgwi3";
const ltrStyles = "lw7up2x";